import {
    SHOW_MODAL_PAYMENTS,
    HIDE_MODAL_PAYMENTS,
    OPEN_MODAL_TUTORIAL,
    CLOSE_MODAL_TUTORIAL
} from './../actions/ModalsActions';

const initialState = {
    openModalPayments: {},
    modalTutorial: {}
}

const ModalReducer = (state = initialState, action) => {

    switch (action.type) {
        case SHOW_MODAL_PAYMENTS:
            return {
                ...state,
                openModalPayments: action.data
            }
        case HIDE_MODAL_PAYMENTS:
            return {
                ...state,
                openModalPayments: action.data
            }
        case OPEN_MODAL_TUTORIAL:
            return {
                ...state,
                modalTutorial: action.data
            }
        case CLOSE_MODAL_TUTORIAL:
            return {
                ...state,
                modalTutorial: action.data
            }
        default:
            return state;
    }
}
export default ModalReducer;